import { render } from "./ScrollTopButton.vue?vue&type=template&id=eb451c58&scoped=true"
import script from "./ScrollTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollTopButton.vue?vue&type=script&lang=js"

import "./ScrollTopButton.vue?vue&type=style&index=0&id=eb451c58&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb451c58"]])

export default __exports__